<div *ngFor="let image of _images;let i = index" class="row">
  <div class="col-sm-9">
    <img [attr.src]="imageUrls[i]" />
  </div>
  <div class="col-sm-3">
    <i class="material-icons delete-icon" (click)="openDeleteConfirmation(image)">delete</i>
  </div>
</div>